import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';

// redux
import { useSelector, useDispatch } from "react-redux";

//constants
import { layoutTypes } from "../constants/layout";

// layouts
import NonAuthLayout from "../Layout/NonAuthLayout";
import VerticalLayout from "../Layout/VerticalLayout/index";
import HorizontalLayout from "../Layout/HorizontalLayout/index";
import { AuthProtected } from "./AuthProtected";

import { authProtectedRoutes, publicRoutes } from "./routes";
import { collection, addDoc, getDocs, getDoc, doc, onSnapshot, where, query, collectionGroup } from "firebase/firestore";
import { onAuthStateChanged, reload } from "firebase/auth";
import { firestore, auth } from '../firebase';
import VerifyEmail from "../Pages/Authentication/VerifyEmail";
import { needsEmailVerification } from "../helpers/emailVerification";
import { setDataCompanies, setLicences } from '../store/companies/actions'
import ListenerDB from './ListenerDB'
import { LicenseManager } from "ag-grid-enterprise";
//please asign your license key to the licenseKey constant as a string below
const licenseKey =
  "CompanyName=Equinix Asia Pacific pte ltd,LicensedGroup=equinixMendixPrivateLib,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=2,LicensedProductionInstancesCount=0,AssetReference=AG-027567,SupportServicesEnd=18_June_2023_[v2]_MTY4NzA0MjgwMDAwMA==4be2c388f9a8a7443c72842dff53d5b2";
LicenseManager.setLicenseKey(licenseKey);
const getLayout = (layoutType) => {
  let Layout = VerticalLayout;
  switch (layoutType) {
    case layoutTypes.VERTICAL:
      Layout = VerticalLayout;
      break;
    case layoutTypes.HORIZONTAL:
      Layout = HorizontalLayout;
      break;
    default:
      break;
  }
  return Layout;
};

const Index = () => {


  const { layoutType } = useSelector((state) => ({
    layoutType: state.Layout.layoutType,
  }));



  useEffect(() => {

    // const user = JSON.parse(localStorage.getItem('authUser'))
    // if (user && user.email) {
    //   setEmail(user.email)
    // }

  }, [])

  const Layout = getLayout(layoutType);

  return (
    <Routes>

      <Route>
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <NonAuthLayout>
                {route.component}
              </NonAuthLayout>
            }
            key={idx}
            exact={true}
          />
        ))}
      </Route>

      <Route>
        {authProtectedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <AuthProtected>
                <CheckCompanies email={'email'} >
                  <ListenerDB />
                  <Layout>
                    {route.title && <PageTitle title={route.title} />}
                    {route.component}
                  </Layout>
                </CheckCompanies>
              </AuthProtected>}
            key={idx}
            exact={true}
          />
        ))}
      </Route>
    </Routes>
  );
};


const CheckCompanies = (props) => {

  const [list, setList] = useState([])
  const [loading, setLoading] = useState(true)
  const [failed, setFailed] = useState(false)
  // null = todavía no se sabe; true = cuenta nueva con clave que no confirmó su email.
  const [mustVerify, setMustVerify] = useState(null)
  const dispatch = useDispatch()
  // Se lee una sola vez, al entrar: si la sesión de Firebase ya no existe, authUser se
  // borra enseguida y la consulta de abajo (que ahora espera a la compuerta) no lo encontraría.
  const [user] = useState(() => JSON.parse(localStorage.getItem('authUser')))

  // Las cuentas nuevas con email y clave confirman su email antes de que se
  // consulte ningún dato. Ante cualquier duda se deja pasar: esto no puede
  // dejar afuera a un cliente por un error nuestro.
  useEffect(() => {
    let answered = false;
    const answer = (value) => { answered = true; setMustVerify(value); };
    // Si Firebase no informa la sesión, se sigue como antes de que existiera esto.
    const timer = setTimeout(() => { if (!answered) answer(false); }, 5000);
    const unsubscribe = onAuthStateChanged(auth, async (fbUser) => {
      clearTimeout(timer);
      try {
        if (fbUser && needsEmailVerification(fbUser)) {
          // Pudo haberlo confirmado desde otro dispositivo: se vuelve a consultar.
          try { await reload(fbUser); } catch (e) { }
          answer(needsEmailVerification(fbUser));
        } else {
          answer(false);
        }
      } catch (e) {
        answer(false);
      }
    }, () => answer(false));
    return () => { clearTimeout(timer); unsubscribe(); };
  }, [])

  useEffect(() => {
    if (mustVerify !== false) return;

    const fetchData = async () => {
      
      try {

        // IF user is admin, get all companies
        if (user.email == 'ticketcontrol.latam_NOVA@gmail.com') {
          const companiesCollectionRef = collection(firestore, "users");
          const companiesSnapshot = await getDocs(companiesCollectionRef);
          const companies = [];
          const licResult = {};
          companiesSnapshot.forEach((doc) => {
            const data = doc.data();
            const company = data.company;
            if (company !== undefined) {
            company.id = doc.id;
            // Adjuntamos monitor_id (IDM) y timestamps de actividad para que el
            // banner de duplicados pueda detectar grupos y resaltar el más reciente.
            company.monitor_id = data.app_config?.monitor_id || null;
            company.lastLunchApp = data.lastLunchApp || null;
            company.app_config_updated_at = data.app_config?.updatedAt || null;
            companies.push(company);
            licResult[doc.id] = data.licence ?? null;
            }
          });

          dispatch(setDataCompanies(companies));
          dispatch(setLicences(licResult));
          const _list = companies.map(company => company.id)
          setList(_list);
          setLoading(false);
        }
        else {
          const promises = [];
          const authCollectionRef = collectionGroup(firestore, "auth");
          const q = query(authCollectionRef, where("email", "==", user.email));

          // //FORZAR CON EMAIL
          // const q = query(
          //   authCollectionRef,
          //   where("email", "==", "naranjo99111@gmail.com")
          // );

          const querySnapshot = await getDocs(q);
          const resultList = [];
          const companies = [];
          const licResult = {};
          querySnapshot.forEach((doc) => {
            const userDocRef = doc.ref.parent.parent; // Referencia al documento "users"
            const result = {
              id: userDocRef.id,
            };
            resultList.push(result.id);
            // Obtener el campo 'company' del documento "users"
            const promise = getDoc(userDocRef).then((userDocSnapshot) => {
              if (userDocSnapshot.exists()) {
                const userData = userDocSnapshot.data();
                let company = userData.company;
                if (company !== undefined) {
                  // Adjuntamos monitor_id (IDM) y timestamps de actividad para
                  // que el banner de duplicados pueda detectar grupos y resaltar
                  // el más reciente.
                  company = {
                    ...company,
                    id: userDocRef.id,
                    monitor_id: userData.app_config?.monitor_id || null,
                    lastLunchApp: userData.lastLunchApp || null,
                    app_config_updated_at: userData.app_config?.updatedAt || null,
                  };
                  companies.push(company);
                }
                licResult[userDocRef.id] = userData.licence ?? null;
              }
            });
            promises.push(promise);
          });

          await Promise.all(promises);

          setList(resultList);
          dispatch(setDataCompanies(companies));
          dispatch(setLicences(licResult));

          setLoading(false);
        }
      } catch (error) {
        console.log(error)
        // No es lo mismo "no pudimos consultar" que "no tienes estacionamientos".
        setFailed(true);
        setLoading(false);
      }
    };

    fetchData();

  }, [mustVerify])


  if (mustVerify) { return <VerifyEmail email={user?.email} onVerified={() => setMustVerify(false)} /> }

  if (loading) { return <Loading /> }


  if (failed) { return <LoadFailed /> }

  if (list.length === 0) { return <NoCompany email={user?.email} /> }

  else {
    return <>{props.children}</>
  }
}

export default Index;



const Loading = () => {

  return (
    <React.Fragment>
      <div className="my-5 pt-5">
        <div className="w-100">
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <div className="text-center">

                  <div>
                    <h4 className="text-uppercase mt-4">Cargando...</h4>
                    <p>Estamos recopilando la información</p>

                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>

    </React.Fragment>
  )
}

const reloadPage = () => {
  window.location.reload();
};

const PageTitle = ({ title }) => {
  useEffect(() => {
    document.title = title
      ? `${title} | TicketControl Monitor`
      : "TicketControl Monitor";
  }, [title]);
  return null;
};

const LoadFailed = () => {

  return (
    <React.Fragment>
      <div className="my-5 pt-5">
        <div className="w-100">
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <div className="text-center">
                  <div>
                    <h4 className="text-uppercase mt-4">No pudimos cargar tus estacionamientos</h4>
                    <p>Revisa tu conexión a internet y vuelve a intentarlo.</p>
                    <button className="btn btn-secondary waves-effect waves-light mt-3 me-2" onClick={reloadPage}>
                      Volver a Cargar
                    </button>
                    <Link to="/logout" className="btn btn-primary waves-effect waves-light mt-3">
                      Salir
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
}

const NoCompany = ({ email }) => {

  return (
    <React.Fragment>
      <div className="my-5 pt-5">
        <div className="w-100">
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <div className="text-center">
                  <div>
                    <h4 className="text-uppercase mt-4">No hay Estacionamiento asignado a esta cuenta</h4>
                    {/* Con varias cuentas de Google es fácil entrar con la equivocada */}
                    {email ? <p>Entraste como <strong>{email}</strong>.</p> : null}
                    <p>Para ver un estacionamiento, ese mismo email tiene que estar autorizado en TicketControl: Configuración -> Auditoría -> Monitor. Si autorizaste otro email, toca «Salir» y entra con ese.</p>
                    {/* Reload Button */}
                    <button className="btn btn-secondary waves-effect waves-light mt-3 me-2" onClick={reloadPage}>
                      Volver a Cargar
                    </button>
                    {/* Logout Button */}
                    <Link to="/logout" className="btn btn-primary waves-effect waves-light mt-3">
                      Salir
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
}